import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Box } from '@chatterbug/aaron'

const TopicInfoSkeleton = ({
  nameSection,
  descriptionSection,
  imageSection,
  children,
}) => {
  return (
    <Flex
      as="article"
      flexWrap={{ _: 'wrap', tablet: 'nowrap' }}
      flexDirection={{ _: 'column-reverse', tablet: 'row' }}
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Box maxWidth={{ _: '100%', tablet: '50%' }}>
        <Box as="h1" variant="text.h3">
          {nameSection}
        </Box>
        {descriptionSection && (
          <Box mt="2x" variant="text.paragraph">
            {descriptionSection}
          </Box>
        )}
        {children}
      </Box>
      {imageSection && (
        <Box
          flexShrink={{ _: 1, tablet: 0 }}
          mt={{ _: 'none', tablet: '7px' }} // `7px` is to vertically align the name and the image
          mb={{ _: '2x', tablet: 0 }}
          ml={{ _: 0, tablet: '2x' }}
          borderRadius="1x"
          width={{ _: '100%', tablet: '40%' }}
          sx={{ overflow: 'hidden' }}
        >
          {imageSection}
        </Box>
      )}
    </Flex>
  )
}

TopicInfoSkeleton.propTypes = {
  nameSection: PropTypes.any.isRequired,
  descriptionSection: PropTypes.any,
  imageSection: PropTypes.any,
  children: PropTypes.any,
}

export default TopicInfoSkeleton
